import CheckIcon from '@mui/icons-material/Check';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import type { SvgIconComponent } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import {
  SyberryTodayAllocationStatus,
  type SyberryTodayProjectAllocationSummary,
} from 'domain/people/syberryToday/types';
import { formatHours } from './utils';

type SyberryTodayAllocationGuidanceProps = {
  allocationSummary: SyberryTodayProjectAllocationSummary;
};

const STATUS_VIEW_BY_STATUS: Record<
  SyberryTodayAllocationStatus,
  {
    color: string;
    icon: SvgIconComponent;
  }
> = {
  [SyberryTodayAllocationStatus.ON_TRACK]: {
    color: 'success.main',
    icon: CheckIcon,
  },
  [SyberryTodayAllocationStatus.BEHIND]: {
    color: 'warning.main',
    icon: WarningAmberIcon,
  },
  [SyberryTodayAllocationStatus.AHEAD]: {
    color: 'info.main',
    icon: AlarmOnIcon,
  },
  [SyberryTodayAllocationStatus.COMPLETED]: {
    color: 'primary.main',
    icon: CheckBoxOutlinedIcon,
  },
};

const SyberryTodayAllocationGuidance = ({ allocationSummary }: SyberryTodayAllocationGuidanceProps) => {
  const statusView = STATUS_VIEW_BY_STATUS[allocationSummary.status];
  const Icon = statusView.icon;

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={0.75} sx={{ mt: 0.75 }}>
        <Icon sx={{ color: statusView.color, fontSize: 18 }} />
        <Typography variant="body1">{allocationSummary.guidanceMessage}</Typography>
      </Stack>

      <Typography variant="body1" mt={1}>
        Recommended allocation: {formatHours(allocationSummary.recommendedHoursToday)}
      </Typography>
    </>
  );
};

export default SyberryTodayAllocationGuidance;
